export default __webpack_public_path__ + "static/SYBG-300797b8370900e3942f1abc791bb35a.webp";